import { type FC, useEffect } from "react";
import { Label } from "@root/shared/components/Label/legacy";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import * as styles from "./styles.css";

export type userSkillsProps = {
  businessTypeName: string;
  skillNames: string[];
};

type Props = {
  userSkills: userSkillsProps[];
  maxSize: number;
};

export const UserSkillsList: FC<Props> = ({ userSkills, maxSize }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  useEffect(() => {
    if (setContainerHeight) {
      // maxSize以上要素の高さがあったらmaxSizeの高さで続きを読むボタンを表示
      setContainerHeight(maxSize);
    }
  }, [setContainerHeight, maxSize]);
  return (
    <>
      {userSkills.map((skill) => (
        <dl key={skill.businessTypeName}>
          <dt className={styles.labelListDt}>{skill.businessTypeName}</dt>
          <dd>
            <ul className={styles.labelList}>
              {skill.skillNames.map((name) => (
                <li key={name}>
                  <Label size="small" filledType="outlined" color="pink" bold>
                    {name}
                  </Label>
                </li>
              ))}
            </ul>
          </dd>
        </dl>
      ))}
    </>
  );
};
